import { ListMenuItem } from "@compass/core";
import { LkPersonTypeId, Permission, PermissionAction, TenantInfo } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { StudentBulkUpdatePageState, studentBulkUpdatePageRoute } from "../StudentBulkUpdatePage/StudentBulkUpdatePage";
import {
  StudentBulkAssignGroupPageState,
  studentBulkAssignGroupPageRoute,
} from "../StudentBulkAssignGroupPage/StudentBulkAssignGroupPage";
import {
  StudentBulkCreateServicesPageState,
  studentBulkCreateServicesPageRoute,
} from "../StudentBulkCreateServicesPage/StudentBulkCreateServicesPage";
import { studentBulkEmailPageRoute, StudentBulkEmailPageState } from "../StudentBulkEmailPage/StudentBulkEmailPage";
import { studentBulkMergePageRoute, StudentBulkMergePageState } from "../StudentBulkMergePage/StudentBulkMergePage";
import {
  createTextingConversationsPageRoute,
  CreateTextingConversationsPageState,
} from "pages/texting/CreateTextingConversationsPage/CreateTextingConversationsPage";
import ApiService from "services/apiService";

export const useStudentListMenuItems = (props: { tenantTextingInfo: TenantInfo | undefined; permission: Permission; selectedIds: number[] }) => {
  const navigate = useNavigate();
  const menuItems: ListMenuItem[] = [];

  if (isAuthorized(props.permission, PermissionAction.Update))
    menuItems.push({
      label: "Update",
      action: (selectedIds: number[]) =>
        navigate(studentBulkUpdatePageRoute.getPath(), {
          state: { selectedIds: selectedIds } as StudentBulkUpdatePageState,
        }),
    });

  if (isAuthorized(Permission.StudentGroup, PermissionAction.Create))
    menuItems.push({
      label: "Assign Group",
      action: (selectedIds: number[]) =>
        navigate(studentBulkAssignGroupPageRoute.getPath(), {
          state: { selectedIds: selectedIds } as StudentBulkAssignGroupPageState,
        }),
    });

  if (isAuthorized(Permission.StudentService, PermissionAction.Create))
    menuItems.push({
      label: "+ New Services",
      action: (selectedIds: number[]) =>
        navigate(studentBulkCreateServicesPageRoute.getPath(), {
          state: { selectedIds: selectedIds } as StudentBulkCreateServicesPageState,
        }),
    });

  if (isAuthorized(props.permission, PermissionAction.Update))
    menuItems.push({
      label: "Send Emails",
      action: (selectedIds: number[]) =>
        navigate(studentBulkEmailPageRoute.getPath(), {
          state: { selectedIds: selectedIds } as StudentBulkEmailPageState,
        }),
    });

  if (isAuthorized(props.permission, PermissionAction.Update)) {
    menuItems.push({
      label: "Merge",
      action: (selectedIds: number[]) =>
        navigate(studentBulkMergePageRoute.getPath(), {
          state: { selectedIds: selectedIds } as StudentBulkMergePageState,
        }),
      disabled: props.selectedIds.length < 2,
    });
  }

  if (props.tenantTextingInfo && props.tenantTextingInfo.canInfobip && isAuthorized(Permission.Texting, PermissionAction.Create)) {
    menuItems.push({
      label: "+ Texting",
      action: (selectedIds: number[]) =>
        navigate(createTextingConversationsPageRoute.getPath(), {
          state: {
            personTypeId: Number(LkPersonTypeId.Student),
            personIds: selectedIds,
          } as CreateTextingConversationsPageState,
        }),
    });
  }

  return menuItems;
};
